import { createActions } from 'redux-actions'

export const INIT_PAGE_PREVIEW_INFO = "INIT_PAGE_PREVIEW_INFO";

export const REQUEST_PAGE_PREVIEW_START = "REQUEST_PAGE_PREVIEW_START";
export const REQUEST_PAGE_PREVIEW_SUCCESS = "REQUEST_PAGE_PREVIEW_SUCCESS";
export const REQUEST_PAGE_PREVIEW_FAIL = "REQUEST_PAGE_PREVIEW_FAIL";

export const REQUEST_DETAIL_PAGE_PREVIEW_START = "REQUEST_DETAIL_PAGE_PREVIEW_START";
export const REQUEST_DETAIL_PAGE_PREVIEW_SUCCESS = "REQUEST_DETAIL_PAGE_PREVIEW_SUCCESS";
export const REQUEST_DETAIL_PAGE_PREVIEW_FAIL = "REQUEST_DETAIL_PAGE_PREVIEW_FAIL";


export const {

  initPagePreviewInfo,

  requestPagePreviewStart,
  requestPagePreviewSuccess,
  requestPagePreviewFail,

  requestDetailPagePreviewStart,
  requestDetailPagePreviewSuccess,
  requestDetailPagePreviewFail,


} = createActions({

  [INIT_PAGE_PREVIEW_INFO]: (req) => ({ req }),

  [REQUEST_PAGE_PREVIEW_START]: (req) => ({ ...req }),
  [REQUEST_PAGE_PREVIEW_SUCCESS]: (res) => ({ res }),
  [REQUEST_PAGE_PREVIEW_FAIL]: (res) => ({ res }),

  [REQUEST_DETAIL_PAGE_PREVIEW_START]: (req) => ({ ...req }),
  [REQUEST_DETAIL_PAGE_PREVIEW_SUCCESS]: (res) => ({ res }),
  [REQUEST_DETAIL_PAGE_PREVIEW_FAIL]: (res) => ({ res }),

})


